// This file is automatically generated. Do not edit manually.

import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType";
import { ConfiguratorAppAccess } from "src/api/generated/erp/configurator/configuratorApp/configuratorAppAccess";
import { ConfiguratorTreeModelSource } from "src/api/generated/erp/configurator/configuratorTree/configuratorTreeModelSource";
import { ConfiguratorInput } from "src/api/generated/io/aavo/applications/db/erp/types/configuratorInput";
import { ConfigurationProductFamilyVersionInputModel } from "src/api/generated/erp/db/types/enums/configurationProductFamilyVersionInputModel";
import { ConfiguratorEvent } from "src/api/generated/erp/configurator/model/configuratorEvent";
import { TransformComponentsResult } from "src/api/generated/erp/configurator/componentTransformation/transformationPipe/transformComponentsResult";
import { SubConfiguratorPartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/subConfiguratorPartConfiguratorType";
import { ConfiguratorVersion } from "src/api/generated/io/aavo/applications/db/erp/types/configuratorVersion";
import { ConfiguratorTreeModel } from "src/api/generated/erp/configurator/configuratorTree/configuratorTreeModel";
import { PartConfigurationAiValidationResult } from "src/api/generated/erp/configurator/validation/partConfigurationAiValidationResult";
import { ConfiguratorTreeItemModel } from "src/api/generated/erp/configurator/configuratorTree/configuratorTreeItemModel";
import { ConfigurationPropertyValues } from "src/api/generated/erp/configurator/model/configurationPropertyValues";
import { IsoDateString } from "src/types/dateTime";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PartConfiguratorFormApi {
	export async function getConfiguratorAppAccess(args: {
		configuratorType: PartConfiguratorType;
	}): Promise<ConfiguratorAppAccess | null> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuratorForm/getConfiguratorAppAccess",
			method: "POST",
			data: {
				configuratorType: args.configuratorType,
			},
		});
		return response === "" ? null : (response as ConfiguratorAppAccess | null);
	}

	export async function getConfigurationHasBeenEditedManually(args: {
		configuratorType: PartConfiguratorType;
	}): Promise<boolean> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuratorForm/getConfigurationHasBeenEditedManually",
			method: "POST",
			data: {
				configuratorType: args.configuratorType,
			},
		});
		return response as boolean;
	}

	export async function getConfiguratorTreeModel(args: {
		rootConfiguratorType: PartConfiguratorType;
		source?: ConfiguratorTreeModelSource | null | undefined;
	}): Promise<PartConfiguratorFormApi_GetConfiguratorTreeModelResponse> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuratorForm/getConfiguratorTreeModel",
			method: "POST",
			data: {
				rootConfiguratorType: args.rootConfiguratorType,
				source: args.source,
			},
		});
		return response as PartConfiguratorFormApi_GetConfiguratorTreeModelResponse;
	}

	export async function resolveConfiguratorState(args: {
		configurationSessionId: string;
		configuratorType: PartConfiguratorType;
		configuratorInput: ConfiguratorInput;
		resolveRecursively: boolean;
	}): Promise<PartConfiguratorFormApi_ResolveConfiguratorPropertyValues> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuratorForm/resolveConfiguratorState",
			method: "POST",
			data: {
				configurationSessionId: args.configurationSessionId,
				configuratorType: args.configuratorType,
				configuratorInput: args.configuratorInput,
				resolveRecursively: args.resolveRecursively,
			},
		});
		return response as PartConfiguratorFormApi_ResolveConfiguratorPropertyValues;
	}

	export async function getConfiguratorInputModel(args: {
		configuratorType: PartConfiguratorType;
	}): Promise<ConfigurationProductFamilyVersionInputModel> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuratorForm/getConfiguratorInputModel",
			method: "POST",
			data: {
				configuratorType: args.configuratorType,
			},
		});
		return response as ConfigurationProductFamilyVersionInputModel;
	}

	export async function resolvePropertyModelState(args: {
		configurationSessionId: string;
		configuratorType: PartConfiguratorType;
		propertyInputValues: Record<string, unknown | null | undefined>;
	}): Promise<PartConfiguratorFormApi_ResolveConfiguratorPropertyValues> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuratorForm/resolvePropertyModelState",
			method: "POST",
			data: {
				configurationSessionId: args.configurationSessionId,
				configuratorType: args.configuratorType,
				propertyInputValues: args.propertyInputValues,
			},
		});
		return response as PartConfiguratorFormApi_ResolveConfiguratorPropertyValues;
	}

	export async function transformComponents(args: {
		configurationSessionId: string;
		configuratorType: PartConfiguratorType;
		configuratorInput: ConfiguratorInput;
		event: ConfiguratorEvent | null | undefined;
	}): Promise<TransformComponentsResult> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuratorForm/transformComponents",
			method: "POST",
			data: {
				configurationSessionId: args.configurationSessionId,
				configuratorType: args.configuratorType,
				configuratorInput: args.configuratorInput,
				event: args.event,
			},
		});
		return response as TransformComponentsResult;
	}

	export async function resolveSubConfiguratorVersion(args: {
		configuratorType: SubConfiguratorPartConfiguratorType;
	}): Promise<ConfiguratorVersion> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuratorForm/resolveSubConfiguratorVersion",
			method: "POST",
			data: {
				configuratorType: args.configuratorType,
			},
		});
		return response as ConfiguratorVersion;
	}

	export async function saveConfiguratorTreeModel(args: { treeModel: ConfiguratorTreeModel }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuratorForm/saveConfiguratorTreeModel",
			method: "POST",
			data: {
				treeModel: args.treeModel,
			},
		});
		return response as void;
	}

	export async function clearSavedConfiguratorTreeModel(args: {
		configuratorType: PartConfiguratorType;
	}): Promise<string | null> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuratorForm/clearSavedConfiguratorTreeModel",
			method: "POST",
			data: {
				configuratorType: args.configuratorType,
			},
		});
		return response === "" ? null : (response as string | null);
	}

	export async function getComponentDocuments(args: {
		configuratorComponentId: number;
	}): Promise<Array<PartConfiguratorFormApi_ComponentDocument>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuratorForm/getComponentDocuments",
			method: "POST",
			data: {
				configuratorComponentId: args.configuratorComponentId,
			},
		});
		return response as Array<PartConfiguratorFormApi_ComponentDocument>;
	}

	export async function getCurrentConfigurationSalesPrice(args: {
		configurationSessionId: string;
		configuratorType: PartConfiguratorType;
		configuratorInput: ConfiguratorInput;
	}): Promise<PartConfiguratorFormApi_GetConfigurationSalesPriceResult | null> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuratorForm/getCurrentConfigurationSalesPrice",
			method: "POST",
			data: {
				configurationSessionId: args.configurationSessionId,
				configuratorType: args.configuratorType,
				configuratorInput: args.configuratorInput,
			},
		});
		return response === "" ? null : (response as PartConfiguratorFormApi_GetConfigurationSalesPriceResult | null);
	}

	export async function getConfiguratorVersionInfo(args: {
		configuratorType: PartConfiguratorType;
	}): Promise<PartConfiguratorFormApi_ConfiguratorVersionInfo> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuratorForm/getConfiguratorVersionInfo",
			method: "POST",
			data: {
				configuratorType: args.configuratorType,
			},
		});
		return response as PartConfiguratorFormApi_ConfiguratorVersionInfo;
	}

	export async function validateConfiguration(args: {
		configurationSessionId: string;
		configuratorType: PartConfiguratorType;
		configuratorInput: ConfiguratorInput;
	}): Promise<PartConfigurationAiValidationResult> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuratorForm/validateConfiguration",
			method: "POST",
			data: {
				configurationSessionId: args.configurationSessionId,
				configuratorType: args.configuratorType,
				configuratorInput: args.configuratorInput,
			},
		});
		return response as PartConfigurationAiValidationResult;
	}

	export async function updateConfiguratorVersions(args: {
		treeItem: ConfiguratorTreeItemModel;
	}): Promise<ConfiguratorTreeItemModel> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuratorForm/updateConfiguratorVersions",
			method: "POST",
			data: {
				treeItem: args.treeItem,
			},
		});
		return response as ConfiguratorTreeItemModel;
	}
}

export interface PartConfiguratorFormApi_GetConfiguratorTreeModelResponse {
	savedConfigurationId: number | null | undefined;
	storageKey: string | null | undefined;
	treeModel: ConfiguratorTreeModel;
	validationEnabled: boolean;
}

export interface PartConfiguratorFormApi_ResolveConfiguratorPropertyValues {
	label: string;
	propertyValues: ConfigurationPropertyValues;
}

export interface PartConfiguratorFormApi_ComponentDocument {
	description: string;
	documentId: number;
}

export interface PartConfiguratorFormApi_GetConfigurationSalesPriceResult {
	priceInSellingCurrency: number;
	priceInSellingCurrencyWithVat: number;
	vatPercent: number;
}

export interface PartConfiguratorFormApi_ConfiguratorVersionInfo {
	partDescription1: string;
	partNo: string;
	partRevisionNote: string;
	partRevisionNumber: number;
	partRevisionValidFrom: IsoDateString | null | undefined;
	productFamilyVersionNumber: number;
}
